import { useQuery } from '@tanstack/react-query';
import { File } from '../index';
import { read } from '../service/api';

type Options = {
  enabled?: boolean;
};

const useFileQuery = (id: File['id'] | undefined, options: Options = {}) => {
  return useQuery({
    queryKey: ['api_single_file', id],
    queryFn: () => read({ id: id! }),
    enabled: !!id && options?.enabled,
  });
};

export default useFileQuery;
